<button (click)="acceptBooking()"
        color="accent"
        flok-button
        [disabled]="loading"
        [fullWidth]="fullWidth"
        *ngIf="status === BookingStatus.Unconfirmed">Accept
</button>
